'use client';

import { PiLegoFill, PiPianoKeysFill, PiSparkleFill } from 'react-icons/pi';
import { useTranslation } from 'react-i18next';
import { getStaticAssetPath } from '@/lib/utils';
import { Banner } from './Banner';
import { Features } from './Features';

export const MainHeroBanner = () => {
  const { t } = useTranslation();

  const features = [
    {
      icon: <PiSparkleFill />,
      title: t('mainPage.features.quality.title'),
      description: t('mainPage.features.quality.description'),
    },
    {
      icon: <PiPianoKeysFill />,
      title: t('mainPage.features.skillLevel.title'),
      description: t('mainPage.features.skillLevel.description'),
    },
    {
      icon: <PiLegoFill />,
      title: t('mainPage.features.practice.title'),
      description: t('mainPage.features.practice.description'),
    },
  ];

  return (
    <Banner
      variant='horizontal'
      imageSrc={getStaticAssetPath('/static/banner-image.webp')}
      imageAlt={t('mainPage.banner.imageAlt')}
      title={
        <>
          {t('mainPage.banner.title')} {' '}
          <span className='text-accent-blue'>{t('mainPage.banner.titleHighlight')}</span> {t('mainPage.banner.titleEnd')}
        </>
      }
      ctaText={t('mainPage.banner.cta')}
      ctaHref='/practice'
    >
      <Features features={features} className='hidden sm:grid' />
    </Banner>
  );
};
